"use client";

import { useState } from "react";
import Image from "next/image";
import { useHeroVideo } from "./HeroVideoContext";

export function ClientHeroVideo({ poster = "/images/hero-poster-new.webp" }: { poster?: string }) {
  const heroVideo = useHeroVideo();
  const [videoLoaded, setVideoLoaded] = useState(false);

  return (
    <>
      <Image
        src={poster}
        alt="Dermalife Clinic"
        fill
        priority
        fetchPriority="high"
        sizes="100vw"
        className="absolute inset-0 -z-30 h-full w-full object-cover object-center"
      />
      {heroVideo && (
        <video
          autoPlay
          loop
          muted
          playsInline
          poster={poster}
          onPlaying={() => setVideoLoaded(true)}
          onLoadedData={() => setVideoLoaded(true)}
          className={`absolute inset-0 -z-20 hidden h-full w-full object-cover md:block transition-opacity duration-700 ${videoLoaded ? "opacity-85" : "opacity-0"}`}
        >
          <source src={heroVideo} type="video/mp4" />
        </video>
      )}
    </>
  );
}
